import React from 'react';
import { useBranding } from 'src/branding/BrandingContextProvider';
import { useDispatch, useSelector } from 'react-redux';
import { applyFilter } from 'src/store/actions/serviceRequestDashboard/filters';
import StatusIcon from 'src/components/StatusIcon/StatusIcon';
import { getStatusConfigs, StatusConfig } from 'src/utils/statusUtils';
import Card from 'src/components/Card';
import Status from 'src/components/Status';
import './StatusOverviewCard.scss';

const toggleArrayState = (state: any, newValue: any) => {
  let newState: any = state ?? [];
  return newState.includes(newValue)
    ? newState.filter((s: any): boolean => s !== newValue)
    : newState.concat(newValue);
};

const StatusOverviewCard = ({
  serviceRequestOverview,
  onSelectStatus,
}: any) => {
  const { branding } = useBranding();
  const dispatch = useDispatch();
  const { Statuses } =
    useSelector((state: any) => state.serviceRequestDashboardFilters) ?? [];

  const handleSelectStatus = (status: any) => {
    const newStatuses: any = toggleArrayState(Statuses, status);
    dispatch(applyFilter('Statuses', newStatuses));
    onSelectStatus();
  };

  const statusConfigs: StatusConfig[] = getStatusConfigs(
    serviceRequestOverview
  );

  return (
    <div className="statusOverviewCard">
      <Card
        title="Status Overview"
        body={
          <div className="statusGrid">
            {statusConfigs.map((statusConfig: StatusConfig, index: number) => (
              <div
                key={index}
                className={`statusItem compact ${
                  Statuses?.includes(statusConfig.label) ? 'selected' : ''
                }`}
                onClick={() => handleSelectStatus(statusConfig.label)}
              >
                <div className="statusContent">
                  <Status
                    icon={
                      <StatusIcon
                        status={statusConfig.label}
                        showLabel={false}
                        size="medium"
                        className="overview-status-icon"
                      />
                    }
                    label={statusConfig.label}
                  />
                </div>
                <div
                  className="statusCount"
                  style={{
                    color: branding?.colours?.text?.emphasis ?? undefined,
                  }}
                >
                  {statusConfig.count}
                </div>
              </div>
            ))}
          </div>
        }
      />
    </div>
  );
};

export default StatusOverviewCard;
